module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('b', [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226322735_09_ack#map1"
    }
  }, [_vm._v("The Amazon, early 1989")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226322735_11_ch2#map2"
    }
  }, [_vm._v("Rivers of the Amazon basin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226322735_14_ch5#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plan of a "), _c('i', [_vm._v("seringal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226322735_15_ch6#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("States and major roads in the Amazon basin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226322735_16_ch7#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian tribes mentioned in the text")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226322735_16_ch7#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gold-producing areas of the Amazon basin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226322735_28_notref#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poles of development in the Amazon basin")])]), _vm._v(" "), _c('p', {
    staticClass: "image-1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap1"
  }, [_c('i', [_vm._v("Indian sketched by Midshipman Gibbon, who accompanied Lieutenant Herndon on a voyage of exploration down the Amazon, under orders from the US government to determine the navigability of the Amazon basin and the “character and extent of its undeveloped commercial resources, whether of the field, the forest, the river or the mine.” By the time of Herndon’s trip the Indian population had already been decimated. Three centuries earlier Orellana’s party had marveled at the extensive indigenous population established along the rivers.")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4be0bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226322735_07_map.vue
// module id = 72
// module chunks = 0